import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'
import Home from '@/views/Home.vue'
import Dashboard from '@/views/Dashboard.vue'
import Locations from '@/views/Locations.vue'
import LoginView from '@/views/LoginView.vue'
import NotFoundView from '@/views/NotFoundView.vue'
import Forbidden from '@/views/Forbidden.vue'
import UploadExcel from '@/views/UploadExcel.vue'
import Import from '@/views/Import.vue'

import * as requests from '@/common/requests'
import * as auth from '@/common/auth'

const routes = [
  { path: '/', redirect: { name: 'Dashboard' } },
  {
    path: '/gegevens',
    name: 'Gegevens',
    component: Home,
    meta: { requiresAuth: true },
  },
  {
    path: '/import',
    name: 'Import',
    component: Import,
    meta: { requiresAuth: true },
  },
  {
    path: '/locations',
    name: 'Locations',
    component: Locations,
    meta: { requiresAuth: true },
  },
  {
    path: '/locations/:id',
    name: 'location-detail',
    component: Locations,
    meta: { requiresAuth: 'Locations' },
  },
  {
    path: '/upload-excel',
    name: 'upload-excel',
    component: UploadExcel,
    meta: { requiresAuth: 'Gegevens' },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Forbidden,
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundView,
  },
]

const router = createRouter({
  // hash history, same as the vue-router 3 default this app used (nginx has no history fallback)
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  store.commit('setNavigating', true)
  try {
    // The permission check only happens after the login status is known, so
    // both requests can run in parallel (getScreenPermissions never throws)
    const permissionsPromise = to.meta.requiresAuth ? requests.getScreenPermissions() : null
    await auth.verifyUserLoginStatus()

    if (to.meta.requiresAuth) {
      if (!store.state.isLoggedIn) {
        next({
          name: 'Login',
          query: {
            redirect: to.path,
          },
        })
      } else {
        try {
          const response = await permissionsPromise
          console.log('Screen permissions: ', response)
          const screens = response.data
          const nextScreen = screens.find(
            (s) => s.name === to.name || s.name === String(to.meta.requiresAuth)
          )

          if (store.state.user.permissions[nextScreen.permission]) {
            next()
          } else {
            next({ name: 'Forbidden', query: { redirect: to.name } })
          }
        } catch (err) {
          console.log('Error when fetching screen data')
          console.error(err)
          next({ name: 'NotFound' })
        }
      }
    } else if (to.name === 'Login' && store.state.isLoggedIn) {
      next({ name: 'Dashboard' })
    } else {
      next()
    }
  } finally {
    store.commit('setNavigating', false)
  }
})

export default router
